import { createState, Downgraded, useState } from '@hookstate/core';
import Helper from '../utility/helper';
import ApiHelper from '../utility/ApiHelper';
import APIURLConstants from '../config/config';
import { NO_ACCESS_PERMISSION } from '../constants/Constant';

const initialState = {
    selectedTab: 0,
    eventDetail: null,
    systemUsers: [],
    permissions: null,
    moduleState: [
        {
            requestStatus: 'To Do',
            modules: []
        },
        {
            requestStatus: 'Pending',
            modules: []
        },
        {
            requestStatus: 'Approved',
            modules: []
        }
    ]
};

const eventState = createState(initialState);

// react hook for consuming
export const useEventState = () => {
    // const newEventState = { ...eventState.attach(Downgraded).get() };
    // if (newEventState.eventDetail == undefined || newEventState.eventDetail === null) {
    //     const eventInfo = Helper.getStorage('eventInfo');
    //     newEventState.eventDetail = eventInfo;
    // }
    // 
    // return useState(newEventState);

    return useState(eventState);
};

export const updateModuleDetailsList = (modulesList) => {
    const eventInfo = Helper.getStorage('eventInfo');
    eventInfo.moduleDetails = modulesList;
    const newEventState = { ...eventState.attach(Downgraded).get() };
    newEventState.eventDetail = eventInfo;
    eventState.set(newEventState)
    Helper.setStorage('eventInfo', eventInfo)
}
export const updateModuleState = async () => {
    const userInfo = Helper.getStorage('userInfo');
    const eventInfo = Helper.getStorage('eventInfo');
    const agentInfo=Helper.getSessionStorage('agentUser')
    const agentConnection = Helper.getSessionStorage('agentConnections');
    if (userInfo && eventInfo) {
        ApiHelper.get(APIURLConstants.GET_EVENT_USER_MODULE_STATUS(eventInfo.eventID, agentConnection && agentInfo? agentInfo.userID:userInfo.userID))
            .then((res) => {
                const newEventState = { ...eventState.attach(Downgraded).get() };
                if (newEventState.eventDetail == null) {
                    newEventState.eventDetail = eventInfo;
                }
                if (res && res.data.length > 0) {
                    // setModulesPopulated(true);

                    let newParticipantModules = [
                        {
                            requestStatus: 'To Do',
                            modules: []
                        },
                        {
                            requestStatus: 'Pending',
                            modules: []
                        },
                        {
                            requestStatus: 'Approved',
                            modules: []
                        }
                    ];
                    const moduleData = res.data;
                    let permissions = [];
                    moduleData.map(item => {
                        // const moduleName = item.module.toLowerCase() == 'registration' ? 'Event Registration' : item.module;

                        let mod = null;
                        // && item.module.toLowerCase() != 'socialresponsibility'
                        if (item.module.toLowerCase() != 'mediacircuit' ) {
                            mod = item.permission != NO_ACCESS_PERMISSION ? {
                                module: item.module,
                                displayName: item.displayName,
                                permission: item.permission,
                            } : null;
                        }
                        permissions.push({
                            module: item.module.toUpperCase(),
                            permission: item.permission,
                        });
                        if (mod && (item.requestStatus == 'To Do' || item.requestStatus == null)) {
                            newParticipantModules[0].modules.push(mod);
                        }
                        if (mod && item.requestStatus == 'Pending') {
                            newParticipantModules[1].modules.push(mod);
                        }
                        if (mod && item.requestStatus == 'Approved') {
                            newParticipantModules[2].modules.push(mod);
                        }
                    });
                    newEventState.moduleState = newParticipantModules;
                    newEventState.permissions = permissions;
                    eventState.set(newEventState);
                    //setParticipantModules(newParticipantModules);
                }
                else {

                    //let newEventState = { ...eventState.attach(Downgraded).get() };
                    newEventState.moduleState = [
                        {
                            requestStatus: 'To Do',
                            modules: []
                        },
                        {
                            requestStatus: 'Pending',
                            modules: []
                        },
                        {
                            requestStatus: 'Approved',
                            modules: []
                        }
                    ];
                    eventState.set(newEventState);
                }
            })
            .catch((error) => {
                console.log('error : ', error);
            });
    }
}

export const getUserEventPermissions = (eventID) => {
    const userInfo = Helper.getStorage('userInfo');
    ApiHelper.get(APIURLConstants.GET_EVENT_USER_PERMISSIONS(eventID, userInfo.userID))
        .then((res) => {
            let newEventState = { ...eventState.attach(Downgraded).get() };
            newEventState.permissions = res.data;
            eventState.set(newEventState);
        })
        .catch((error) => {
            console.log('error : ', error);
        });
}
export const resetState = () => {
    eventState.set({
        selectedTab: 0,
        eventDetail: null,
        systemUsers: [],
        permissions: null,
        moduleState: [
            {
                requestStatus: 'To Do',
                modules: []
            },
            {
                requestStatus: 'Pending',
                modules: []
            },
            {
                requestStatus: 'Approved',
                modules: []
            }
        ]
    }
    );
}